import { render, staticRenderFns } from "./DepositSummary.vue?vue&type=template&id=3bca0072&scoped=true&"
import script from "./DepositSummary.vue?vue&type=script&lang=js&"
export * from "./DepositSummary.vue?vue&type=script&lang=js&"
import style0 from "./DepositSummary.vue?vue&type=style&index=0&id=3bca0072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca0072",
  null
  
)

export default component.exports